import axios from 'axios';
import qs from 'qs';
import { isObject, showErrMessage } from '@/utils'
import { getSign, getStamp, getRandom } from '@/utils/util'
import LoginUserHelper from '@/utils/LoginUserHelper'
import md5 from 'js-md5';

window.requestPullToRefresh = (res) => {
};
window.requestPullToRefreshCallBack = (res) => {
};

const service = axios.create({
  baseURL: '/',
  timeout: 10 * 1000, // request timeout
});

service.interceptors.request.use((config) => {
  let time = parseInt(Date.now() / 1000)
  let key = 'D9POt82A8KTH83ug'
  if (!config.multi) {
    config.data = {
      ...config.data,
      sign: md5(key + time),
      time
    }
  }
  const userInfo = LoginUserHelper.getUserInfo();
  if (userInfo.token) {
    config.headers['Authorization'] = userInfo.token;
  }
  return config;
}, (error) => {
  console.log(error);
  Promise.reject(error);
});

service.interceptors.response.use(
  (response) => {
    if (response.data.code == 10000) {
      // 先清空之前的数据
      LoginUserHelper.clearLoginData();

      window.location.href = '/login';
      
      // 创建未完成的Promise对象阻止后续请求
      return new Promise(() => {});
    }
    return response.data;
  },
  (error) => Promise.reject(error),
);

export default service;
